import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/_guards/auth.guard';
import { AppNotfoundComponent } from './consola/notfound/app.notfound.component';
import { AppLoginComponent } from './consola/login/app.login.component';
import { AppVerificarCambioComponent } from './consola/verificar-cambio/app.verificar-cambio.component';
import { AppMainComponent } from './app.main.component';
import { InicioComponent } from './consola/inicio/inicio.component';
import { RegistroComponent } from './consola/registro/registro.component';
import { RecuperarContrasenaComponent } from './consola/recuperar-contrasena/recuperar-contrasena.component';
import { AppVerificarActivacionComponent } from './consola/verificar-activacion/app.verificar-activacion.component';
import { RecepcionTkComponent } from './consola/recepcion-tk/recepcion-tk.component';
import { EvaluacionesComponent } from './evaluaciones/evaluaciones.component';
import { EvaluacionCompetenciasComponent } from './evaluacion-competencias/evaluacion-competencias.component';
import { FichaComponent } from './ficha/ficha.component';
import { ConsultasComponent } from './consultas/consultas.component';
import { FiltroCandidatosComponent } from './filtro-candidatos/filtro-candidatos.component';
import { HeadHunterComponent } from './head-hunter/head-hunter.component';
import { HojaVidaCandidatoComponent } from './hoja-vida-candidato/hoja-vida-candidato.component';
import { CrearRequerimientoCargoClienteComponent } from './crear-requerimiento-cargo-cliente/crear-requerimiento-cargo-cliente.component';
import { ReqHeadHunterComponent } from './req-head-hunter/req-head-hunter.component';
import { DiasServicioComponent } from './dias-servicio/dias-servicio.component';
import { PersonaAsignadaComponent } from './persona-asignada/persona-asignada.component';
import { DisponibilidadComponent } from './disponibilidad/disponibilidad.component';
import { AnsComponent } from './ans/ans.component';
import { ProcesosComponent } from './procesos/procesos.component';
import { IdiomasComponent } from './idiomas/idiomas.component';
import { VolumenDatosComponent } from './volumen-datos/volumen-datos.component';
import { EjecutarConsultaComponent } from './ejecutar-consulta/ejecutar-consulta.component';
import { ConsultasEjecutarComponent } from './consultas-ejecutar/consultas-ejecutar.component';
import { EstadoProcesoComponent } from './estado-proceso/estado-proceso.component';
import { ProcesosContratacionComponent } from './procesos-contratacion/procesos-contratacion.component';
import { SolicitudesBackendComponent } from './solicitudes-backend/solicitudes-backend.component';


export const routes: Routes = [
    {
        path: '', canActivate: [AuthGuard], component: AppMainComponent,
        children: [
            { path: '', canActivate: [AuthGuard], component: InicioComponent },
            { path: 'inicio', canActivate: [AuthGuard], component: InicioComponent },
            { path: 'evaluaciones', canActivate: [AuthGuard], component: EvaluacionesComponent},
            { path: 'evaluacion-competencias', canActivate: [AuthGuard], component: EvaluacionCompetenciasComponent},
            { path: 'ficha', canActivate: [AuthGuard], component: FichaComponent},
            { path: 'dias_servicio', canActivate: [AuthGuard], component: DiasServicioComponent},
            { path: 'personal_asignado', canActivate: [AuthGuard], component: PersonaAsignadaComponent},
            { path: 'horario_atencion', canActivate: [AuthGuard], component: DisponibilidadComponent},
            { path: 'ans', canActivate: [AuthGuard], component: AnsComponent},
            { path: 'procesos', canActivate: [AuthGuard], component: ProcesosComponent},
            { path: 'idiomas', canActivate: [AuthGuard], component: IdiomasComponent},
            { path: 'volumen-datos', canActivate: [AuthGuard], component: VolumenDatosComponent},
            { path: 'consultas', canActivate: [AuthGuard], component: ConsultasComponent },
            { path: 'estado-proceso', canActivate: [AuthGuard], component: EstadoProcesoComponent },
            { path: 'proceso-contratacion', canActivate: [AuthGuard], component: ProcesosContratacionComponent },
            { path: 'ejecutar-consulta', canActivate: [AuthGuard], component: ConsultasEjecutarComponent},
            { path: 'filtro-candidatos', canActivate: [AuthGuard], component: FiltroCandidatosComponent },
            { path: 'head-hunter', canActivate: [AuthGuard], component: HeadHunterComponent },
            { path: 'hoja-vida-candidato/:idCandidato/:numero_id', canActivate: [AuthGuard], component: HojaVidaCandidatoComponent },
            { path: 'crear-requerimiento-cargo-cliente', canActivate: [AuthGuard], component: CrearRequerimientoCargoClienteComponent },
            { path: 'req-head-hunter', canActivate: [AuthGuard], component: ReqHeadHunterComponent },
            { path: 'solicitudes-backend', canActivate: [AuthGuard], component: SolicitudesBackendComponent },
        
        ],
    },
    { path: 'login', component: AppLoginComponent },
    { path: 'registro', component: RegistroComponent },
    { path: 'recuperar-contrasena/:token', component: RecuperarContrasenaComponent },
    { path: 'verificacion-cambio/:token', component: AppVerificarCambioComponent },
    { path: 'verificacion-activacion/:token', component: AppVerificarActivacionComponent },
    { path: 'recepcion', component: RecepcionTkComponent },
    { path: 'notfound', component: AppNotfoundComponent },
    { path: '**', redirectTo: '/notfound' }

];

export const AppRoutes: ModuleWithProviders<any> = RouterModule.forRoot(
    routes,
    {
        scrollPositionRestoration: 'enabled',
        useHash: true
    }
);